<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="料架唯一编号">
                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select v-model="queryCondition.status" class="handle-input">
                  <el-option key="1" label="1" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="料架类型编号">
                <el-select v-model="queryCondition.materialNo" class="handle-input">
                  <el-option key="1" label="是" value="是"></el-option>
                  <el-option key="0" label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="料架类型名称">
                <el-select v-model="queryCondition.materialName" class="handle-input">
                  <el-option key="1" label="是" value="是"></el-option>
                  <el-option key="0" label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="query-btn-row">

          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item label="创建日期">
                <el-date-picker class="handle-input" v-model="queryCondition.date" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button class="btn" type="primary" @click="queryData">搜索</el-button>
              <el-button type="primary">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="apply">料架唯一编号申请</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table">
        <el-table-column prop="mateCode" label="料架唯一编码"></el-table-column>
        <el-table-column prop="no" label="料架类型编号"></el-table-column>
        <el-table-column prop="mateName" label="料架类型名称"></el-table-column>
        <el-table-column prop="createDate" label="创建日期"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog title="料架唯一编号申请" :visible.sync="applyDialog">
      <el-form :model="applyForm" :label-position="labelPosition">
        <el-form-item label="料架类型编号">
          <el-input v-model="applyForm.mateCode"></el-input>
        </el-form-item>
        <el-form-item label="料架类型名称">
          <el-input v-model="applyForm.mateName"></el-input>
        </el-form-item>
        <el-form-item label="申请数量">
          <el-input v-model="applyForm.applyCount"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="applyDialog = false">取 消</el-button>
        <el-button type="primary" @click="applyMateCode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'mate-code',
  data() {
    return {
      tableData: [{
        mateCode: '123456',
        no: '00000000',
        mateName: 'red',
        createDate: '2019-09-09',
        status: '9999'
      }],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        mateCode: '',
        status: '',
        date: '',
        materialNo: '',
        materialName: ''
      },
      applyForm: {
        mateCode: '',
        mateName: '',
        applyCount: 0
      },
      applyDialog: false
    }
  },
  methods: {
    queryData() {
      console.dir(this.queryCondition);
    },
    /**
     * 翻页事件
     */
    handleCurrentChange() {

    },
    /**
     * 料架唯一编号申请
     */
    apply() {
      this.applyDialog = true;
    },
    applyMateCode() {

    }
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
</style>